import {SvgIconProps, SvgIcon} from '@mui/material';
import React from 'react';

export const EditPlusIcon = ({...props}: SvgIconProps) => {
  const StrokeColor = props.color === 'primary' ? '#31CDD3' : '#181C32';
  return (
    <SvgIcon
      width="32"
      height="32"
      viewBox="0 0 24 24"
      fill="none"
      strokeWidth="1.25"
      strokeLinejoin="round"
      strokeLinecap="round"
      xmlns="http://www.w3.org/2000/svg"
      stroke={StrokeColor}
      {...props}>
      <path d="M4 20h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4"></path>
      <path d="M13.5 6.5l4 4"></path>
      <path d="M16 19h6"></path>
      <path d="M19 16v6"></path>
    </SvgIcon>
  );
};
